import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ForceUpdateService } from './force-update.service';
import * as _ from 'lodash';
import { version } from 'punycode';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { RedirectService } from '../redirect/redirect.service';
import { ActivatedRoute } from '../../../node_modules/@angular/router';

declare var $: any;

@Component({
    selector: 'app-forcesupdate',
    templateUrl: './force-update.component.html',
    styleUrls: ['./force-update.component.scss']
})
export class ForceUpdateComponent implements OnInit {
    versionObj = {
    };
    errMessage: string = '';
    versionForm: FormGroup;
    osModal: String;
    osModal1: String;
    versions: any;
    updateVersionId: any;

    constructor(
        private _formBuilder: FormBuilder,
        private _forceUpdateService: ForceUpdateService,
        private _capabilityEngineService: CapabilityEngineService,
        private _redirectService: RedirectService,
        private _activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        const pathData = this._activatedRoute.data['_value'];

        if (this.canPerform(pathData.capabilities)) {
            this.getAppVersion();
        }

        this.versionForm = this._formBuilder.group({
            version: ['', [Validators.maxLength(50), Validators.required]],
            releaseDate: ['', Validators.required],
        });
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }

    closeModal() {
        $('#versionmodal').modal('toggle');
        this.versionForm.reset();
    }

    getAppVersion() {
        this._forceUpdateService.getAppVersions()
            .subscribe(
                (result) => {
                    console.log('result ', result['result']);
                    this.versions = result['result'];
                },
                (err) => {
                    console.log('err ', err);
                    this.errMessage = err.error.message;
                }
            );

    }
    addVersion() {
        this.errMessage = '';
        if (this.versionForm.valid) {
            this.versionForm.value.platform = this.osModal;
            this._forceUpdateService.addConfig(this.versionForm.value)
                .subscribe(
                    (result) => {
                        console.log('result ', this.versionForm);
                        this.closeModal();
                        this.getAppVersion();
                    },
                    (err) => {
                        console.log('err ', err);
                        this.errMessage = err.error.message;
                    }
                );
        } else {
            this.validateAllFormFields(this.versionForm);
        }

    }

    forceUpdate() {
        this.errMessage = '';
        let updateObj = {
            '_id': this.updateVersionId
        };
        this._forceUpdateService.forceUpdate(updateObj)
            .subscribe(
                (result) => {
                    console.log('result ', result);
                    $('#forceupdate').modal('toggle');
                    this.getAppVersion();
                },
                (err) => {
                    console.log('err ', err);
                    this.errMessage = err.error.message;
                }
            );

    }


    openModal(os) {
        this.errMessage = undefined;
        this.osModal = os === 'ANDROID' ? 'ANDROID' : 'IOS';
        $('#versionmodal').modal('show');
    }

    openModal1(os1) {
        this.updateVersionId = os1;
        this.osModal = os1 === 'ANDROID' ? 'ANDROID' : 'IOS';
        $('#forceupdate').modal('show');
    }

    isFieldValid(field: string) {
        return !this.versionForm.get(field).valid && this.versionForm.get(field).touched;
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            } else if (control instanceof FormArray) {
                _.forEach(control.controls, (data: FormGroup) => {
                    this.validateAllFormFields(data);
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/force-update/force-update.component.ts